import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AnalyticsTypeSwitcher from './AnalyticsTypeSwitcher';
import GenerateReportWizard from '../../GenerateReport/Wizard/GenerateReportWizard';
import './AnalyticsDashboardHeader.css';
import SessionsDateRangeSelector from '../../Sessions/Filters/SessionsDateRangeSelector';
import RangeFilter from '../../Sessions/Filters/SessionsRangeFilter';
import RecordingsRangeFilter from '../../Recordings/Filters/RecordingsRangeFilter';
import { ReportStatus } from '../../../Reducks/Reports/ReportsActions';
import { getSessions, filterSessionsByCount } from '../../../Reducks/Sessions/SessionsActions';
import { Route, Switch, withRouter } from 'react-router';
import { connect } from 'react-redux';
import { toggleGenerateReportModal as generateReportModalToggle } from '../../../Reducks/Reports/ReportsActions';
import { Button } from 'reactstrap';
import RecordingsDateRangeSelector from '../../Recordings/Filters/RecordingsDateRangeSelector';
import Notification from '../../GenerateReport/Notification';
import { RECORDINGS_OVERVIEW, SESSIONS_OVERVIEW } from '../../../Telemetry/Mixpanel/Constants/mixpanelConstants';
import { getRecordings } from '../../../Reducks/Recordings/RecordingsActions';

export class AnalyticsDashboardHeader extends Component {
  static propTypes = {
    isBig: PropTypes.bool.isRequired,
    reduced_reports: PropTypes.object,
    toggleGenerateReportModal: PropTypes.func,
    match: PropTypes.object
  };

  render() {
    const { isBig } = this.props;
    const {
      match,
      toggleGenerateReportModal,
      reduced_reports,
      reduced_user,
      reduced_sessions,
      reduced_recordings,
      getSessions,
      getRecordings
    } = this.props;
    const { isGenerateReportOpen, reportFetchStatus } = reduced_reports;
    return (
      <div className="analyticsDashboardHeader">
        <AnalyticsTypeSwitcher />
        <div className="analyticsDashboardHeaderButtons">
          {!isBig && (
            <Switch>
              <Route
                exact
                path={match.url + '/sessions'}
                render={props => (
                  <SessionsButtons {...props} reduced_sessions={reduced_sessions} getSessions={getSessions} />
                )}
              />
              <Route
                exact
                path={match.url + '/recordings'}
                render={props => (
                  <RecordingsButtons {...props} reduced_recordings={reduced_recordings} getRecordings={getRecordings} />
                )}
              />
            </Switch>
          )}
          {!reduced_user.entitlements.isRestrictReportDownloadEnabled && (
            <BuildReportButton
              toggleGenerateReportModal={toggleGenerateReportModal}
              isGenerateReportOpen={isGenerateReportOpen}
              disabled={reportFetchStatus === ReportStatus.FETCHING}
              isBig={isBig}
            />
          )}
        </div>
      </div>
    );
  }
}

export const SessionsButtons = props => {
  const mixpanelData = {
    action: SESSIONS_OVERVIEW
  };
  const { reduced_sessions, getSessions, filterSessionsByCount } = props;
  return (
    <React.Fragment>
      <RangeFilter
        uniqueId={'sessionsRangeFilterInDashboardHeader'}
        isBig={false}
        mixpanelData={mixpanelData}
        reduced_sessions={reduced_sessions}
        filterSessionsByCount={filterSessionsByCount}
      />
      <SessionsDateRangeSelector
        uniqueId={'sessionsDateRangeSelectorInDashboardHeader'}
        mixpanelData={mixpanelData}
        isBig={false}
        reduced_sessions={reduced_sessions}
        getSessions={getSessions}
      />
    </React.Fragment>
  );
};

export const RecordingsButtons = props => {
  const mixpanelData = {
    action: RECORDINGS_OVERVIEW
  };
  const { reduced_recordings, getRecordings } = props;
  return (
    <React.Fragment>
      <RecordingsRangeFilter
        uniqueId={'recordingsRangeFilterInDashboardHeader'}
        isBig={false}
        mixpanelData={mixpanelData}
      />
      <RecordingsDateRangeSelector
        uniqueId={'recordingsDateRangeSelectorInDashboardHeader'}
        mixpanelData={mixpanelData}
        reduced_recordings={reduced_recordings}
        getRecordings={getRecordings}
        isBig={false}
      />
    </React.Fragment>
  );
};

export const BuildReportButton = ({ toggleGenerateReportModal, isGenerateReportOpen, isBig, disabled }, { t }) => {
  return (
    <div>
      {isBig ? (
        <Button
          id="createReportFromHeader"
          className={'button-dark-mode-override'}
          color="primary"
          disabled={disabled}
          onClick={toggleGenerateReportModal}>
          {t('buttons.buildReport')}
        </Button>
      ) : (
        <i
          className={`togo-icon togo-icon-file-txt mobileHeaderIcons ${disabled ? 'disabledIcons' : ''}`}
          onClick={() => !disabled && toggleGenerateReportModal()}
        />
      )}
      <GenerateReportWizard toggle={toggleGenerateReportModal} isOpen={isGenerateReportOpen} isBig={isBig} />
      <Notification isBig={isBig} />
    </div>
  );
};
BuildReportButton.propTypes = {
  toggleGenerateReportModal: PropTypes.func,
  disabled: PropTypes.bool,
  isGenerateReportOpen: PropTypes.bool,
  isBig: PropTypes.bool
};
BuildReportButton.contextTypes = {
  t: PropTypes.func
};
export default withRouter(
  connect(
    state => ({
      reduced_reports: state.reduced_reports,
      reduced_user: state.reduced_user,
      reduced_sessions: state.reduced_sessions,
      reduced_recordings: state.reduced_recordings
    }),
    {
      toggleGenerateReportModal: generateReportModalToggle,
      getSessions: getSessions,
      filterSessionsByCount: filterSessionsByCount,
      getRecordings: getRecordings
    }
  )(AnalyticsDashboardHeader)
);



// WEBPACK FOOTER //
// ./src/GoToWebinar/Dashboard/Header/AnalyticsDashboardHeader.js